import React, { useState, useRef, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import axios from "axios";
import chatbotIcon from "./assets/chatIcon.png";
import half_logo from "./assets/half_logo.png";
import "./css/chatbotStyle.css";

// AUTOMATIC ENVIRONMENT SWITCHER:
// If running locally, use the Vite proxy path. If live on mbsmw.org, use the absolute chatbot engine domain.
const API_URL = window.location.hostname === "localhost" || window.location.hostname === "192.168.0.5"
  ? "/api/message"
  : "https://chatbot.mbsmw.org/api/message";

const ChatbotIcon = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "Hello, Welcome to Malawi Bureau of Standards! How can we help you today?",
    },
  ]);
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);

  const toggleChat = () => setIsChatOpen(!isChatOpen);

  const handleSendMessage = async () => {
    if (!userInput.trim()) return;

    const messageText = userInput;

    setMessages((prev) => [...prev, { sender: "user", text: messageText }]);
    setUserInput("");
    setIsTyping(true);

    try {
      // Uses the smart dynamic URL mapped above
      const response = await axios.post(
        API_URL,
        { message: messageText },
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          }
        }
      );

      const botReply = response.data?.data?.reply || "Sorry, something went wrong.";

      setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          {
            sender: "bot",
            text: botReply,
          },
        ]);
        setIsTyping(false);
      }, 600);
    } catch (error) {
      console.error("Chat error details:", error);

      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text: "Unable to reach server. Please try again later.",
        },
      ]);

      setIsTyping(false);
    }
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  return (
    <>
      {/* Floating Chat Icon */}
      <div className="chatbot-icon" onClick={toggleChat}>
        <img src={chatbotIcon} alt="Chatbot Icon" width="40" height="40" />
      </div>

      {/* Chat Window */}
      {isChatOpen && (
        <div className="chatbot-interface">
          <div className="chatbot-header">
            <div className="header-left">
              <img src={half_logo} alt="MBS Logo" className="header-logo" />
              <div>
                <h4>MBS Chatbot</h4>
                <small>Online</small>
              </div>
            </div>
            <button onClick={toggleChat}>×</button>
          </div>

          <div className="chatbot-messages">
            {messages.map((msg, i) => (
              <div key={i} className={`msg ${msg.sender}`}>
                {msg.sender === "bot" && (
                  <img src={half_logo} alt="bot" width="25" />
                )}
                <span>{msg.text}</span>
                {msg.sender === "user" && <FaUserCircle />}
              </div>
            ))}

            {isTyping && <div className="typing">MBS is typing...</div>}

            <div ref={messagesEndRef} />
          </div>

          <div className="chatbot-input">
            <input
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
              placeholder="Type a message..."
            />
            <button onClick={handleSendMessage}>Send</button>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatbotIcon;